import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  AddCircleOutlineOutlined as AddIcon,
} from "@material-ui/icons";
import { Button } from "@material-ui/core";

import { validations } from "../../../utils/validationUtils";
import SimpleList from "../../common/SimpleList";
import FeatureFormModal from "./FeaturesFormModal";
import ConfirmationDialog from "../../common/ConfirmationDialog";
import * as STOCK from "../../../redux/actions/stocks";
import * as CARS from "../../../redux/actions/cars";
import * as NOTIFICATION from "../../../utils/notification";
import * as CONSTANTS from "../../../utils/constants";
import Header from "../../common/SearchableHeader";
import NoOptions from '../../common/subComponents/AutoCompleteInput/NoOptions'

const styles = (theme) => ({
  brand: {
    borderRight: "1px solid #e0e0e0",
    width: "50%",
  },
  model: {
    width: "50%",
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  addButton: {
    padding: "8px 20px",
    fontSize: "15px",
    width: "110px",
    marginTop: "15px",
    display: "flex",
  },
  subtitle: {
    fontSize: "35px",
    paddingTop: "20px",
    color: theme.palette.primaryColor,
    display: "block",
    width: "350px",
  },
  header: {
    width: "100%",
    height: 70,
  },
  listContainer: {
    padding: 27,
    overflow: "auto",
  },
  addIconStyle: {
    paddingRight: 5,
  },
  withoutSidebar: {
    padding: "24px 36px 24px 0px",
  },
});

class Feature extends Component {
  featureToEdit = {};
  featureToDelete = {};

  state = {
    features: [],
    count: 0,
    from: 0,
    search: "",
    rowsPerPage: CONSTANTS.DEFAULT_ROWS_PER_PAGE_VALUE,
    roles: [],
    openModal: false,
    modalFields: this.initialFields,
    openConfirmationModal: false,
    modalType: CONSTANTS.CREATE,
  };

  initialFields = [
    {
      value: '', type: 'autoCompletionInput', label: this.props.languageReducer.labels.brand, name: 'carBrandId',
      options: [],
      getOptions: search => this.getCarBrands(search),
      noOptions: <NoOptions text='Add a carBrand' classes={styles.addButton}></NoOptions>,
      validation: {
          checks: [validations.notEmpty]
      }
  },
    {
      value: "",
      type: "text",
      label: this.props.languageReducer.labels.code,
      name: "code",
      validation: {
        checks: [validations.notEmpty],
      },
    },
    {
      value: "",
      type: "text",
      label: this.props.languageReducer.labels.description,
      name: "description",
      validation: {
        checks: [validations.notEmpty],
      },
    },
  
  ];

  componentDidMount() {
    this.getFeatures();
  }

  getCarBrands = (search) =>
    this.props
      .getCarBrands({
        search,
      })
      .then((response) =>
        Promise.resolve(this.mapForOptions(response.carBrands))
      );

  //aux function returns initialField index
  indexOfInitialField = (initialFields, searchedNameInFields) =>
    initialFields.findIndex((f) => f.name === searchedNameInFields);

  //aux function map for options
  mapForOptions = (rows) =>
    rows.map((row) => ({
      label: row.name,
      value: row.id,
    }));

  //populate modalFieldsCopy
  populateModalFieldsOptions = (modalFieldsRef, field, values) => {
    let index = this.indexOfInitialField(modalFieldsRef, field);

    if (index === -1) {
      modalFieldsRef[index].options = [];
    } else {
      modalFieldsRef[index].options = this.mapForOptions(values);
    }
  };

  getFeatures = () => {
    this.props.get({ carBrandId: undefined, code: this.state.search }).then((featureResponse) => {
      this.setState({
        features: featureResponse.optionals.rows.map((feature, index) => {
          return {
            index: index + 1,
            _id: feature.id,
            code: feature.code,
            description: feature.value,
            brandName: feature.carBrand ? feature.carBrand.name : "-",
          };
        }),
        openModal: false,
        count: featureResponse.count,
        modalFields: this.initialFields,
        openConfirmationModal: false,
      });
    });
  };

  clearForm = () => {
    //first clear options from
    this.setState({ modalFields: this.initialFields });
  };

  openFormModalHandler = () => {
    this.clearForm();

    let modalFieldsCopy = [...this.state.modalFields].map((field) => ({
      ...field,
    }));
    
    this.setState({
      openModal: true,
      modalType: CONSTANTS.CREATE,
      modalFields: modalFieldsCopy,
    });

  };

  onCreateHandler = (fields) => {
    this.props
      .create({...fields, value: fields.description})
      .then(() => {
        NOTIFICATION.success(this.props.languageReducer.create.success);
        this.getFeatures();
      })
      .catch(() =>
        NOTIFICATION.error(this.props.languageReducer.create.failure)
      );
  };

  onEditHandler = (fields) => {

    return this.props
      .edit(this.featureToEdit._id, {...fields, value: fields.description})
      .then(() => {
        this.getFeatures();
        NOTIFICATION.success(this.props.languageReducer.edit.success);
      })
      .catch(() => NOTIFICATION.error(this.props.languageReducer.edit.failure));
  };

  onDeleteHandler = () => {
    this.props
      .delete(this.featureToDelete._id)
      .then(() => {
        NOTIFICATION.success(this.props.languageReducer.delete.success);
        this.getFeatures();
      })
      .catch(() =>
        NOTIFICATION.error(this.props.languageReducer.delete.failure)
      );
  };

  toggleEditModal = (feature) => {
    let carBrands = this.props
      .getCarBrands({ from: this.state.from, limit: this.state.rowsPerPage })
      .then((result) => result.carBrands);
    let getFeatureById = this.props
      .getById(feature._id)
      .then((result) => result);
    this.featureToEdit = feature;

    Promise.all([carBrands, getFeatureById]).then((values) => {
      let modalFieldsCopy = [...this.state.modalFields].map((field) => {
        if(field.name === "carBrandId"){
          return {
              ...field,
              label: values[1]["carBrand"].name,
              value: values[1][field.name],
            }
          }

        if(field.name == 'description'){
          return { ...field, value: values[1].value};
        }

        return { ...field, value: values[1][field.name] };
      });


      this.populateModalFieldsOptions(modalFieldsCopy, "carBrandId", values[0]);

      this.setState({
        modalFields: modalFieldsCopy,
        openModal: true,
        modalType: CONSTANTS.EDIT,
      });
    });
  };

  closeFormModalHandler = () => this.setState({ openModal: false });
  openConfirmationModalHandler = () =>
    this.setState({ openConfirmationModal: true });
  closeConfirmationModalHandler = () =>
    this.setState({ openConfirmationModal: false });

  changeRowsPerPageHandler = (rowsPerPage) => {
    this.setState({ rowsPerPage }, () => this.getFeatures());
  };

  changePageHandler = (currentFrom) => {
    this.setState({ from: currentFrom }, () => this.getFeatures());
  };

  onCancelHandler = () => {
    this.setState({ openModal: false, modalFields: this.initialFields });
  };

  onSearch = (search) => this.setState({ search }, this.getFeatures);

  render() {
    const { classes } = this.props;
    return (
      <>
        <ConfirmationDialog
          open={this.state.openConfirmationModal}
          cancelButtonText={
            this.props.languageReducer.confirmationDialog.cancelButtonText
          }
          acceptButtonText={
            this.props.languageReducer.confirmationDialog.acceptButtonText
          }
          text={`${this.props.languageReducer.confirmationDialog.text} ${this.featureToDelete.code}?`}
          onCancel={() => this.setState({ openConfirmationModal: false })}
          onClose={() => this.setState({ openConfirmationModal: false })}
          onAccept={this.onDeleteHandler}
        />
        {this.state.openModal ? (
          <FeatureFormModal
            language={this.props.languageReducer}
            type={this.state.modalType}
            fields={this.state.modalFields}
            open={this.state.openModal}
            submitButtonText={
              this.state.modalType === CONSTANTS.CREATE
                ? this.props.languageReducer.formModal.create
                : this.props.languageReducer.formModal.firstEdit
            }
            onSave={(data) =>
              this.state.modalType === CONSTANTS.CREATE
                ? this.onCreateHandler(data.fields)
                : this.onEditHandler(data.fields)
            }
            onCancel={this.onCancelHandler}
            title={
              this.state.modalType === CONSTANTS.CREATE
                ? this.props.languageReducer.formModal.add
                : this.props.languageReducer.formModal.edit
            }
            maxWidth="sm"
          />
        ) : null}
        <div className={classes.header}>
          <Header
            title={this.props.languageReducer.simpleTable.title}
            onSearch={this.onSearch}
            placeholder={this.props.languageReducer.searchPlaceholder}
          />
        </div>
        <div
          className={`${
            !this.props.sidebarReducer.displaySidebar
              ? this.props.classes.withoutSidebar
              : ""
          } ${this.props.classes.listContainer}`}
        >
          <SimpleList
            selectedOption={CONSTANTS.FEATURE_OPTIONS}
            headerFields={["Cod", "Descriere", "Brand Masina"]}
            items={this.state.features}
            actionsTitle={this.props.languageReducer.simpleTable.actionsTitle}
            disableBorders
            actions={[
              {
                tooltip: this.props.languageReducer.simpleTable.actions.delete,
                onClick: (event, row) => {
                  this.featureToDelete = row;
                  this.setState({ openConfirmationModal: true });
                },
                icon: <DeleteIcon />,
              },
              {
                tooltip: this.props.languageReducer.simpleTable.actions.edit,
                onClick: (event, row) => this.toggleEditModal(row),
                icon: <EditIcon />,
              },
            ]}
            onSelect={(feature) => this.toggleEditModal(feature)}
            headerButton={{
              tooltip: "",
              icon: (
                <Button
                  className={classes.addButton}
                  variant="contained"
                  color="primary"
                >
                  <AddIcon className={classes.addIconStyle} />
                  {
                    this.props.languageReducer.simpleTable.headerButton
                      .buttonText
                  }
                </Button>
              ),
              onClick: this.openFormModalHandler,
            }}
            search={{
              onSearch: this.onSearch,
            }}
            countTitle={this.props.languageReducer.features}
            rowsPerPage={this.state.rowsPerPage}
            count={this.state.count}
            changeRowsPerPage={this.changeRowsPerPageHandler}
            changePageHandler={this.changePageHandler}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (reducers) => ({
  languageReducer: reducers.languageReducer.i18n.features,
  sidebarReducer: reducers.sidebarReducer,
});

const mapDispatchToProps = (dispatch) => ({
  get: (queryParams) => dispatch(STOCK.getOptionals(queryParams)),
  edit: (featureId, feature) =>
    dispatch(STOCK.editOptional(featureId, feature)),
  create: (feature) => dispatch(STOCK.createOptional(feature)),
  delete: (featureId) => dispatch(STOCK.deleteOptional(featureId)),
  getById: (featureId) => dispatch(STOCK.getOptionalById(featureId)),
  getCarBrands: (queryParams) => dispatch(CARS.brand.get(queryParams)),
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Feature)
);
